<template>
  <div class="center-screen">
    <p>
      <img
        :src="require('@/assets/images/icons/sad.svg')"
        style="width:30vw;max-width:150px;"
      />
    </p>
    <p class="text-faded">Sorry, nothing here...<strong>(404)</strong></p>
    <a
      class="button is-primary errorB"
      color="secondary"
      style="width:200px;"
      @click="$router.push('/')"
      >Go back</a
    >
  </div>
</template>

<style>
.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}
.errorB {
  margin-top: 30px;
}
</style>

<script>
export default {
  name: 'Error404'
};
</script>
